import { useQuery } from 'react-query';
import type { UseQueryResult } from 'react-query';
import { getServiceProducts } from '../api';
import type { ServiceProductsResponse } from '../api/service-products/model';
import { SERVICE_PRODUCTS_QUERY_KEY, SERVICE_QUERY_CONFIG } from './config';

export const useServiceProducts = (
  id: number | undefined,
): UseQueryResult<ServiceProductsResponse> => {
  return useQuery(SERVICE_PRODUCTS_QUERY_KEY, () => getServiceProducts(id as number), {
    enabled: id !== undefined,
    ...SERVICE_QUERY_CONFIG,
  });
};
